<template>
  <div class="box">
    <i class="iconfont icon-iconfontzhizuobiaozhun22"></i>
    <span>{{placeholder}}</span>
  </div>
</template>
<script type="text/ecmascript-6">
export default{
  props: {
    placeholder: {
      type: String,
      default: '搜索'
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .box
    padding 0 size(28)
    line-height size(60)
    color #999
    font-size size(28)
    background #f5f5f5
    border-radius size(28)
</style>



// WEBPACK FOOTER //
// src/components/base/search/search-fake.vue